import { MessageCircle } from "lucide-react";
import { useLanguage, waLink } from "@/i18n";

export default function WhatsAppFloat() {
  const { t } = useLanguage();
  return (
    <a
      href={waLink(t("wa_message") + " ")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-24 md:bottom-6 right-4 md:right-6 z-50 inline-flex items-center gap-2 bg-medblue text-ivory text-xs font-medium uppercase tracking-[0.15em] px-5 py-4 shadow-lg shadow-medblue/30 hover:bg-ink transition-colors duration-300 rounded-full"
    >
      <MessageCircle size={16} strokeWidth={1.5} />
      <span className="hidden sm:inline">{t("wa_float")}</span>
    </a>
  );
}
